import { call, put, takeEvery } from '@redux-saga/core/effects';
import { SAVE_NEW_HADASIM } from '../actions/actionsTypes';
import { postDataWithHeaders } from '../httpClient';
import { SaveHadasimActionType } from '../actions/saveHadasimAction';
import { resetUser } from '../slices/userSlice/userSlice';

export function* saveHadasim(action: SaveHadasimActionType): any {
  try {
    yield call(postDataWithHeaders, '/api/v1/admin/hadasims', action.headers, {
      kind: action.kind,
      price: action.price,
      active: true,
    });
    if (action.onSuccess) {
      action.onSuccess();
    }
  } catch (e: any) {
    if (e?.status === 401) {
      yield put(resetUser());
      alert('Sorry, Login Expired! Please Login again');
    } else {
      alert('Failed to save Hadasim');
    }
  }
}

export function* watchSaveHadasim() {
  yield takeEvery(SAVE_NEW_HADASIM, saveHadasim);
}
